import { render, staticRenderFns } from "./Automobile.vue?vue&type=template&id=5eb0e81f&"
import script from "./Automobile.vue?vue&type=script&lang=js&"
export * from "./Automobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports